/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-17 10:00:00
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ButtonGroup, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { WarningType } from 'src/components/views/theme-setup-v3/theme-setup-form/theme-turbo-warning';

type Props = {
  active: boolean,
  warningType: Boolean,
  warningThemeInfo: React.ReactNode,
  onCancel: () => void,
  onRemove: () => void
};

type ComposedProps = Props & WithI18nProps;

class WarningCheckingThemeModal extends Component<ComposedProps> {
  render() {
    const { active, warningType, onCancel, onRemove, warningThemeInfo, i18n } = this.props;

    return (
      <Modal
        open={active}
        onClose={onCancel}
        title={'Warning'}
        footer={
          <div className="btn-actions-warning">
            <ButtonGroup spacing="tight">
              <div className="btn-cancel">
                <Button onClick={onCancel}>
                  {i18n.translate('AdminHTML.Common.Action.cancel')}
                </Button>
              </div>
              {warningType !== WarningType.IN_SHOPIFY_INTEGRATION_THEME_LIVE && (
                <div className="btn-remove">
                  <Button onClick={onRemove}>
                    {i18n.translate('AdminHTML.ShopifyIntegration.Actions.removeFormer')}
                  </Button>
                </div>
              )}
            </ButtonGroup>
          </div>
        }>
        <Modal.Section>{warningThemeInfo}</Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(connect(null, null)(WarningCheckingThemeModal));
